import React from 'react';
import s from './PromptBlock.module.css';
import { useSelector } from 'react-redux';
import { selectCurrentProject } from '../../../../store/selectors/projectSelectors';
import IconDiamond from '../../../../shared/ui/icons/IconDiamond';
import Tooltip from '../../../../shared/ui/tooltip/Tooltip';
import PremiumFeatureTooltip from '../premium-feature-tooltip/PremiumFeatureTooltip';
import { selectUserProfile } from '../../../../store/selectors/authSelectors';

const PropertiesBlock = () => {
    const currentProject = useSelector(selectCurrentProject);
    const userProfile = useSelector(selectUserProfile);

    return (
        <div className={s.container}>
            <div className={s.block_container}>
                <p className={s.header}>Prompt Description</p>
                <p className={s.prompt}>{currentProject?.prompt}</p>
            </div>
            <div className={s.block_container}>
                <p className={s.header}> Category</p>
                <p className={s.prompt}>{userProfile?.content_for}</p>
            </div>
            <div className={s.block_container}>
                <p className={s.header}> Type</p>
                <p className={s.prompt}>{currentProject?.content_type}</p>
            </div>
            <div className={s.block_container}>
                <p className={s.header}>Tone Selected</p>
                <div className={s.tone_container}>
                    {currentProject?.tone && currentProject.tone.length > 0 ? (
                        currentProject.tone.map((el, i) => (
                            <p key={i} className={s.prompt}>
                                {el.value}
                            </p>
                        ))
                    ) : (
                        <p className={s.empty_prompt}>No tone selected</p>
                    )}
                </div>
            </div>

            <div className={s.block_container}>
                <p className={s.header}>Voice</p>
                <p className={currentProject?.voice ? s.prompt : s.empty_prompt}>
                    {currentProject?.voice ? currentProject.voice : 'No voice selected'}
                </p>
            </div>

            {/*<div className={s.block_container}>*/}
            {/*    <p className={s.header}>References</p>*/}
            {/*    <div className={s.prompt}>*/}
            {/*        {currentProject?.references && currentProject.references.length > 0*/}
            {/*            ? currentProject.references*/}
            {/*            : 'No references selected'}*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={s.block_container}>
                <p className={s.header}>Schedule</p>
                <div className={s.schedule}>
                    <p className={s.header}>No posts scheduled</p>
                    <PremiumFeatureTooltip />
                </div>
            </div>
        </div>
    );
};

export default PropertiesBlock;
